// Create the provider component
import type { ReactNode } from "react";
import FuseNavigationHelper from "@fuse/utils/FuseNavigationHelper";
import { NavigationContext } from "@/components/theme-layouts/components/navigation/contexts/NavigationContext";
import { APP_NAVIGATION } from "@/configs/configRotas/app-rotas.constants";

const navigationContextValue = {
	navigationItems: FuseNavigationHelper.flattenNavigation(APP_NAVIGATION),
};

export function NavigationContextProvider({ children }: { children: ReactNode }) {
	return <NavigationContext value={navigationContextValue}>{children}</NavigationContext>;
}
